import React from 'react'
import Navbar from '../../components/navbar/Navbar'
import AboutSection from './components/AboutSection'

const About = () => {
  return (
    <div>
    <Navbar/>
    <AboutSection/>
    
    </div>
  )
}

export default About
